import { Link } from "react-router-dom";
import { SERVICE_AREAS, MAP_EMBED_URL, ADDRESS } from "../../mocks/businessData";

const areaDetails = [
  { city: "London", desc: "Our Home Base", primary: true },
  { city: "St. Thomas", desc: "Elgin County", primary: false },
  { city: "Sarnia", desc: "Lambton County", primary: false },
  { city: "Kitchener", desc: "Waterloo Region", primary: false },
  { city: "Stratford", desc: "Perth County", primary: false },
  { city: "Grand Bend", desc: "Huron County", primary: false },
];

export default function ServiceAreasSection() {
  return (
    <section className="bg-cream-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div>
            <span className="font-sans text-xs font-semibold tracking-[0.2em] uppercase text-rust-600 mb-4 block">
              Where We Work
            </span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal leading-tight mb-6">
              Proudly Serving London &amp; Southwestern Ontario
            </h2>
            <p className="font-sans text-base text-stone-600 leading-relaxed mb-8 max-w-lg">
              For over 30 years, Upper Canada Landscape has been transforming properties across London, Ontario and the surrounding region. We bring the same premium standard to every community we serve.
            </p>

            {/* Area grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
              {areaDetails.map((area) => (
                <div
                  key={area.city}
                  className={`rounded-lg p-4 border transition-all ${
                    area.primary
                      ? "bg-rust-700 border-rust-700 text-white"
                      : "bg-white border-stone-200 hover:border-rust-300"
                  }`}
                >
                  <div className="flex items-center gap-2 mb-1">
                    <i className={`ri-map-pin-2-fill text-sm ${area.primary ? "text-rust-200" : "text-rust-600"}`}></i>
                    <span className={`font-sans text-sm font-semibold ${area.primary ? "text-white" : "text-charcoal"}`}>
                      {area.city}
                    </span>
                  </div>
                  <p className={`font-sans text-xs ${area.primary ? "text-rust-200" : "text-stone-500"}`}>
                    {area.desc}
                  </p>
                </div>
              ))}
            </div>

            <p className="font-sans text-sm text-stone-500 mb-6">
              Also serving: {SERVICE_AREAS.slice(6).join(", ")} and many more communities throughout Southwestern Ontario.
            </p>

            <Link
              to="/location"
              className="inline-flex items-center gap-2 font-sans text-sm font-semibold text-rust-700 hover:text-rust-800 cursor-pointer group"
            >
              View all service areas
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>

          {/* Right: Map pointing to actual business address */}
          <div className="rounded-xl overflow-hidden border border-stone-200">
            <div className="w-full h-80 md:h-96">
              <iframe
                title="Upper Canada Landscape - 563 Wonderland Rd N, London, Ontario"
                src={MAP_EMBED_URL}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="bg-white p-4 border-t border-stone-100 flex items-center justify-between">
              <div>
                <p className="font-sans text-sm font-semibold text-charcoal">Upper Canada Landscape</p>
                <p className="font-sans text-xs text-stone-500">{ADDRESS}</p>
              </div>
              <a
                href="https://maps.google.com/maps?q=563+Wonderland+Rd+N,+London,+ON+N6H+3E2"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="font-sans text-xs font-semibold text-rust-700 hover:text-rust-800 flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                Get Directions <i className="ri-external-link-fill"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
